import { gql } from '@apollo/client'

const GET_CHART_IMAGE = gql`
  query getChartImage($input: ChartImageInput!) {
    getChartImage(input: $input)
  }
`

export { GET_CHART_IMAGE }
